import React from 'react';
import { useParams } from "react-router-dom";

import NaboraHero from './modules/nabora/NaboraHero';
import NaboraAbout from './modules/nabora/NaboraAbout';
import NaboraMonthSector from './modules/nabora/NaboraMonthSector';
import NaboraQuickGrid from './modules/nabora/NaboraQuickGrid';
import NaboraEconomy from './modules/nabora/NaboraEconomy';
import NaboraCTA from './modules/nabora/NaboraCTA';
import NaboraFooter from './modules/nabora/NaboraFooter';

const NaboraHome = () => {
  const { slug } = useParams();
  
  return (
    <div className="min-h-screen bg-[#0a0a0f] text-white overflow-x-hidden font-sans">
      <NaboraHero slug={slug} />
      <NaboraAbout slug={slug} />
      <NaboraMonthSector slug={slug} />
      <NaboraQuickGrid slug={slug} />
      <NaboraEconomy slug={slug} />
      <NaboraCTA slug={slug} />
      <NaboraFooter slug={slug} />
    </div>
  );
};

export default NaboraHome;